import { useSelector } from 'react-redux';
import { isCurrentEnterpriseGroupBillingEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { useCommanderSelector } from '@mews-commander/utils';
import { getBillingAccountUrl, getBillingGroupUrl } from '../../../../modules/navigation/billing';

interface BillingUrlProps {
    accountId?: string;
    groupId?: string;
    billId?: string;
    orderItemId?: string;
}

export const useBillingUrl = ({ accountId, billId, groupId, orderItemId }: BillingUrlProps) => {
    const isGroupBillingEnabled: boolean = useSelector(isCurrentEnterpriseGroupBillingEnabled);

    const accountUrl = useCommanderSelector((state) =>
        accountId ? getBillingAccountUrl(state, { accountId, id: billId, orderItemId }) : undefined
    );
    const groupUrl = useCommanderSelector((state) =>
        groupId ? getBillingGroupUrl(state, { groupId, accountId, id: billId, orderItemId }) : undefined
    );

    if (groupUrl && isGroupBillingEnabled) return groupUrl;

    return accountUrl;
};
